import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
// Components
import FullButton from "../Buttons/FullButton";
// Assets
import HeaderImage from "../../assets/img/images/main.jpg";
import QuotesIcon from "../../assets/svg/Quotes";
import Dots from "../../assets/svg/Dots";

import Slide1 from "../../assets/img/images/slide1.jpg";
import Slide2 from "../../assets/img/images/slide2.jpg";
import Slide3 from "../../assets/img/images/slide3.jpg";

import Card1 from "../../assets/img/images/sap2.jpg";
import Card2 from "../../assets/img/images/img6.jpg";
import Card3 from "../../assets/img/images/web-design.jpg";
import Card4 from "../../assets/img/images/cad2.jpg";
import Card5 from "../../assets/img/pageimages/Solidworks1.jpeg";
import Card6 from "../../assets/img/pageimages/Catia1.jpeg";
import Card7 from "../../assets/img/pageimages/Rhinocer1.jpeg";
import Card8 from "../../assets/img/images/audodesk1.jpg";
import Card9 from "../../assets/img/pageimages/Finalcutpro1.jpeg";
import Card10 from "../../assets/img/images/autodesk2.jpg";
import Card11 from "../../assets/img/images/maya1.jpg";
import Card12 from "../../assets/img/images/animaker1.jpg";
import Card13 from "../../assets/img/pageimages/Gimp1.jpeg";



const carouselSettings = {
  infinite: true,
  speed: 3000,
  autoplay: true,
  autoplaySpeed: 5000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  dots: false,
  fade: true,
};
const serviceSliderSettings = {
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 4,
  slidesToScroll: 4,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [


    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 4,
      },
    },
  ],
};


export default function Header() {
  return (
    <Wrapper id="home">
      {/* Background Carousel */}
      <CarouselContainer>
        <Slider {...carouselSettings}>
          <img src={Slide1} alt="Slide 1" />
          <img src={Slide2} alt="Slide 2" />
          <img src={Slide3} alt="Slide 3" />
        </Slider>
      </CarouselContainer>

      {/* ✅ Side-by-side layout */}
      <ContentRow>
        <LeftSide>
          <h2 className="extraBold " style={{ marginBottom: "10px", color: "#fdba00" }}>COMPANY VISION</h2>
          <HeaderP >
            A global consulting, software engineering, and R&D company, trusted by innovative customers to address their complex technical challenges.
          </HeaderP>

          <h2 className="extraBold " style={{ marginBottom: "10px", color: "#fdba00" }}>COMPANY MISSION</h2>
          <HeaderP >
            CREATING A BETTER FUTURE FOR OUR EMPLOYEES, CLIENTS, AND COMMUNITIES.
          </HeaderP>

          <BtnWrapper>
            <FullButton title="Get Started" />
          </BtnWrapper>
        </LeftSide>

        <RightSide>
          <ImageWrapper>
            <Img src={HeaderImage} alt="office" />
            <QuoteWrapper className="flexCenter darkBg radius8">
              <QuotesWrapper>
                <QuotesIcon />
              </QuotesWrapper>
              <div>
                <p className="font15 whiteColor">
                  <em>Friends, such as we desire, are dreams and fables. Friendship demands the ability to do without it.</em>
                </p>
                <p className="font13 orangeColor textRight" style={{ marginTop: '10px' }}>Ralph Waldo Emerson</p>
              </div>
            </QuoteWrapper>
            <DotsWrapper>
              <Dots />
            </DotsWrapper>
          </ImageWrapper>
        </RightSide>
      </ContentRow>

      {/* ✅ Services Section */}
      <BottomSection>
        <h2 className="extraBold font20" style={{ textAlign: "center", marginBottom: "30px", color: "#7620ff", fontSize: "2.0rem" }}>
          Our Services
        </h2>

        <ServiceSlider {...serviceSliderSettings}>

          <Card><a href="/servicepages/sap">
            <img src={Card1} alt="Service 1" />

            <p className="font13 semiBold">SAP</p>
          </a>          </Card>
          <Card>
          <a href="/servicepages/powerbi">
            <img src={Card2} alt="Service 2" />
           
              <p className="font13 semiBold">Power BI</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/webdesign">
            <img src={Card3} alt="Service 3" />
            
              <p className="font13 semiBold">Web Design</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/caddesign">
            <img src={Card4} alt="Service 4" />
              <p className="font13 semiBold">CAD design</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/solidworks">
            <img src={Card5} alt="Service 5" />
              <p className="font13 semiBold">Solid Works</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/catia">
            <img src={Card6} alt="Service 6" />
              <p className="font13 semiBold">CATIA</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/rhinocer">
            <img src={Card7} alt="Service 7" />
              <p className="font13 semiBold">RhinocerOS3D</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/autodesk">
            <img src={Card8} alt="Service 8" />
              <p className="font13 semiBold">Autodesk Revit  </p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/finalcutpro">
            <img src={Card9} alt="Service 9" />
              <p className="font13 semiBold">Final CutPro</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/cinema">
            <img src={Card10} alt="Service 10" />
              <p className="font13 semiBold">Cinema 4D</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/autodeskmaya">
            <img src={Card11} alt="Service 11" />
              <p className="font13 semiBold">Autodesk maya</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/animaker">
            <img src={Card12} alt="Service 12" />
              <p className="font13 semiBold">Animaker</p>
            </a>
          </Card>
          <Card>
          <a href="/servicepages/gimp">
            <img src={Card13} alt="Service 13" />
              <p className="font13 semiBold">GIMP</p>
            </a>
          </Card>
        </ServiceSlider>
      </BottomSection>
    </Wrapper>
  );
}

// Styled Components
const ServiceSlider = styled(Slider)`
  max-width: 1200px;
  margin: 0 auto;

  .slick-slide > div {
    display: flex;
    justify-content: center;
        padding: 0 15px; // <-- Add this!

  }

  .slick-dots li button:before {
    font-size: 12px;
    margin-top: 10px;
  }

  .slick-dots li.slick-active button:before {
    color: #ff9900;
  }
`;

const Wrapper = styled.section`
  width: 100%;
  min-height: 100vh;
  position: relative;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
    font-family: 'Poppins', sans-serif;

`;

const CarouselContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    
  }

  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide > div {
    height: 100%;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1;
  }
`;

const ContentRow = styled.div`
  display: flex;
  width: 100%;
  align-items: center; /* vertically center */
  justify-content: space-between; 
  position: relative;
  z-index: 2;
  padding: 60px 5% ;
  gap: 40px;
  text-align:justify-content-between;
 

  @media (max-width: 960px) {
    flex-direction: column;
    padding: 40px 20px;
  }
`;

const LeftSide = styled.div`
  width: 50%;
  z-index: 2;

  @media (max-width: 960px) {
    width: 100%;
    text-align: center;
  }
`;

const RightSide = styled.div`
  width: 50%;
  z-index: 2;

  @media (max-width: 960px) {
    width: 100%;
  }
`;

const HeaderP = styled.p`
  max-width: 470px;
  padding: 15px 0 30px;
  line-height: 1.5rem;
  color: #fff;

  @media (max-width: 960px) {
    max-width: 100%;
    text-align: center;
  }
`;

const BtnWrapper = styled.div`
  max-width: 190px;

  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 960px) {
    justify-content: center;
  }
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;

  @media (max-width: 560px) {
    width: 80%;
  }
`;

const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 20px;
  max-width: 330px;
  padding: 30px;
  background: #333;
  border-radius: 8px;
  color: white;
  z-index: 3;

  @media (max-width: 960px) {
    left: 20px;
  }

  @media (max-width: 560px) {
    bottom: -50px;
  }
`;

const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;

const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;

  @media (max-width: 960px) {
    right: 100px;
  }

  @media (max-width: 560px) {
    display: none;
  }
`;

const BottomSection = styled.div`
  width: 100%;
   padding: 5rem 5rem 7rem;
  background-color: #f9f9f9;
  position: relative;
  z-index: 2;
`;


const Card = styled.div`
  width: 100%;
  max-width: 250px;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  overflow: hidden;
  text-align: center;
  padding: 20px;
margin: 0 20px;
  img {
    width: 100%;
    height: 150px;
    object-fit: cover;
    margin-bottom: 15px;
    border-radius: 8px;
  }

  p {
    margin: 5px 0;
  }
`;

